const columns = [
    { accessorKey: 'name', header: 'Name', meta: { sortBy: 'Name' }, cell: ({ getValue }) => getValue() ?? '—' },
    { accessorKey: 'abbreviation', header: 'Abbreviation', meta: { sortBy: 'Abbreviation' }, cell: ({ getValue }) => getValue() ?? '—' },
];
export default columns;
